import React from 'react'
import { Alert, } from 'antd'

import './Error.scss'

const Error = ({ reason, }) => (
  <div>
    <Alert
      message="Error"
      description={ `There was an error fetching the data. Reason: ${reason}` }
      type="error"
      showIcon
    />
  </div>
)

export default Error



// WEBPACK FOOTER //
// ./src/components/Error/Error.jsx